var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'OrganizationHome'
      }
    }
  }, [_vm._v(" 組織資料設定 ")]), _c('b-breadcrumb-item', {
    on: {
      "click": _vm.goBackOrList
    }
  }, [_vm._v(_vm._s("API Token 管理列表") + " ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.isReadOnly ? "查看API Token" : _vm.isEditing ? "編輯API Token" : "新增API Token") + " ")])], 1)], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isReadOnly ? "查看API Token" : _vm.isEditing ? "編輯API Token" : "新增API Token") + " ")]), _c('div', {
    staticClass: "col-12 col-xl-8 mt-3"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "*通路"
    }
  }, [_c('b-form-select', {
    staticClass: "mr-3",
    attrs: {
      "state": _vm.v$.token.merchant_id.$error ? false : null,
      "disabled": _vm.isReadOnly,
      "options": _vm.merchants
    },
    model: {
      value: _vm.token.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.token, "merchant_id", $$v);
      },
      expression: "token.merchant_id"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.token.merchant_id.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "*類型"
    }
  }, [_c('b-form-select', {
    staticClass: "mr-3",
    attrs: {
      "state": _vm.v$.token.type.$error ? false : null,
      "disabled": _vm.isReadOnly,
      "options": _vm.types
    },
    model: {
      value: _vm.token.type,
      callback: function callback($$v) {
        _vm.$set(_vm.token, "type", $$v);
      },
      expression: "token.type"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.token.type.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "備註"
    }
  }, [_c('b-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "rows": "4",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.token.memo,
      callback: function callback($$v) {
        _vm.$set(_vm.token, "memo", $$v);
      },
      expression: "token.memo"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "過期時間"
    }
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.zh,
      "format": _vm.dateFormatter,
      "bootstrap-styling": "",
      "disabled": _vm.isReadOnly
    },
    on: {
      "input": _vm.formatDate
    },
    model: {
      value: _vm.token.expired_at,
      callback: function callback($$v) {
        _vm.$set(_vm.token, "expired_at", $$v);
      },
      expression: "token.expired_at"
    }
  })], 1), _vm.isReadOnly || _vm.isEditing ? _c('div', [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "App ID"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly || _vm.isEditing
    },
    model: {
      value: _vm.token.app_id,
      callback: function callback($$v) {
        _vm.$set(_vm.token, "app_id", $$v);
      },
      expression: "token.app_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "App Secret"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly || _vm.isEditing
    },
    model: {
      value: _vm.token.app_secret,
      callback: function callback($$v) {
        _vm.$set(_vm.token, "app_secret", $$v);
      },
      expression: "token.app_secret"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "Token"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly || _vm.isEditing
    },
    model: {
      value: _vm.token.token,
      callback: function callback($$v) {
        _vm.$set(_vm.token, "token", $$v);
      },
      expression: "token.token"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "最後存取時間"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly || _vm.isEditing
    },
    model: {
      value: _vm.token.last_access,
      callback: function callback($$v) {
        _vm.$set(_vm.token, "last_access", $$v);
      },
      expression: "token.last_access"
    }
  })], 1)], 1) : _vm._e()], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goBackOrList
    }
  }, [_vm._v("返回 ")]), !_vm.isReadOnly ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("儲存")]) : _vm._e()], 1)])], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }